import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerGroupsDataGrid } from "src/components/views/erp/sales/masterData/customerGroups/CustomerGroupsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerGroups")({
	staticData: { title: i18n.t("customer_groups"), legacyViewKey: "customerGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerGroupsDataGrid />;
}
